import React from "react";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";
import styled from "styled-components";

import BaseComponent from "./BaseComponent";
import ErrorDisplay from "./ErrorDisplay";
import AppHeaderSmall from "../components/common/AppHeaderSmall";
import MainContentWrapper from "./common/MainContentWrapper";
import PasswordRequirement from "./common/PasswordRequirement";
import SiteWrapper from "./common/SiteWrapper";

import { isPasswordFormatValid } from "../util/regexHelper";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const TextH1 = styled.h1`
  font-size: 40px;
  text-align: center;
`;


class ConfirmAccount extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      password: null,
      passwordConfirm: null,
      passwordsValid: false,
      showSuccessMessage: false,
      showActivityIndicator: false,
    };
    this.confirmAccount = this.confirmAccount.bind(this);
  }

  async confirmAccount() {
    const password = this.state.password;

    this.errorManager.reset();

    if (password === null || password === "") {
      this.errorManager.addError(
        "You must enter a password to confirm your account"
      );
      this.forceUpdate();
      return;
    }

    this.setState({ showActivityIndicator: true });
    this.forceUpdate();

    let response;

    try {
      response = await this.identityApi.confirmAccount(
        this.params.email,
        this.state.password,
        this.params.token
      );
    } catch (err) {
      console.log(err);
      if (err.response) {
        switch (err.response.status) {
          case 500:
            this.errorManager.addError("Unexpected Error");
            break;
          default:
            this.errorManager.addError("Unknown Error: " + err);
        }
        this.errorManager.addError(err.response.data);
      }
      this.setState({ showActivityIndicator: false });
      this.forceUpdate();
      return;
    }

    if (!response.data) {
      this.errorManager.addError(
        "There was a problem confirming your account."
      );
      this.setState({ showActivityIndicator: false });
      this.forceUpdate();
      return;
    }
    this.setState({
      showSuccessMessage: true,
      showActivityIndicator: false,
    });
  }

  checkConfirmPassword(value) {
    if (this.state.password === value) {
      this.validateEntry();
    }
  }

  validateEntry() {
    this.errorManager.reset();
    if (this.state.password != null && this.state.passwordConfirm != null) {
      //somethign in there for everything. Start validating.

      //check passwords for entry and equality
      if (this.state.password != null && this.state.passwordConfirm != null) {
        this.setState({ passwordsEntered: true });
      } else {
        this.setState({ passwordsEntered: false });
      }

      if (this.state.password !== this.state.passwordConfirm) {
        this.setState({ passwordsValid: false });
        return;
      }

      if (this.state.password.length < 8) {
        this.setState({ passwordsValid: false });
        return;
      }

      if (isPasswordFormatValid(this.state.password)) {
        this.setState({ passwordsValid: true });
      } else {
        // not valid
        this.setState({ passwordsValid: false });
        this.errorManager.addError(
          "Password must contain at least one upper case, lower case, number, and special character."
        );
        this.forceUpdate();
      }
    }
  }

  render() {
    return (
        <SiteWrapper>
        <AppHeaderSmall/>
        <MainContentWrapper>
        {this.state.showSuccessMessage && this.errorManager.getErrorCount() === 0 ? (
            <Wrapper>
              <TextH1>
                Thank you.
                <br />
                Account e-mail is confirmed and password is set.
                <br />
                You may now login to your Hospitable Viking application.
                <br />
              </TextH1>
            </Wrapper>
        ) : (

        <Grid
            textAlign="center"
            verticalAlign="middle"
            padded
          >
            <Grid.Column style={{ maxWidth: 400 }}>
              <Header as="h2" textAlign="center" style={{color: "#1AACD9", marginBottom:30}}>
                Create Password
              </Header>
              <Form size="large">
                <Segment stacked>
                  <Form.Input
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    onBlur={(e) => {
                      this.validateEntry();
                    }}
                    fluid
                    icon="lock"
                    iconPosition="left"
                    placeholder="Password"
                    type="password"
                    autoComplete="new-password"
                    disabled={!this.state.validParameters}
                  />
                  <Form.Input
                    onChange={(e) => {
                      this.checkConfirmPassword(e.target.value);
                      this.setState({ passwordConfirm: e.target.value });
                    }}
                    onBlur={(e) => {
                      this.validateEntry();
                    }}
                    fluid
                    icon="lock"
                    iconPosition="left"
                    placeholder="Confirm"
                    type="password"
                    autoComplete="new-password"
                    disabled={!this.state.validParameters}
                  />
                  <PasswordRequirement
                    style={{ marginBottom: "15px", textAlign: "left" }}
                  />
                </Segment>
              </Form>
              <Button
                onClick={() => {
                    this.confirmAccount();
                }}
                style={{marginTop:10}}
                loading={this.state.showActivityIndicator}
                color="blue"
                fluid
                size="large"
                disabled={
                    !this.state.passwordsValid ||
                    this.state.showSuccessMessage ||
                    !this.state.validParameters
                }
                >
                Set Password
            </Button>
              {this.errorManager.getErrorCount() > 0 ? (
                <div style={{width:370, marginTop:20}}>
                    <ErrorDisplay errorManager={this.errorManager} />
                </div>
            ) : null}
            </Grid.Column>
          </Grid>
        )}

        </MainContentWrapper>
      </SiteWrapper>
    );
  }

  async componentDidMount() {
    try {
      if (!this.params.email) {
        this.errorManager.addError("Missing email parameter");
      }
      if (!this.params.token) {
        this.errorManager.addError("Missing token parameter");
      }
      this.setState({
        validParameters: this.params.email && this.params.token,
      });
    } catch (err) {
      this.errorManager.addError("Failed to confirm email.");
      console.log(err);
    }
    this.setState({ loaderActive: false });
  }
}

export default ConfirmAccount;
